const LK_Alarm =({color,width,height})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                    <style>
                    .cls-1 {
                        fill: #005c8e;
                        stroke-width: 0px;
                    }
                    </style>
                </defs> */}
             <path class="cls-1" d="M70.78,14.82c.17-.82.26-1.68.26-2.54C71.04,5.5,65.54,0,58.76,0s-12.29,5.5-12.29,12.28c0,.87.09,1.72.26,2.54-16.46,5.11-28.41,20.47-28.41,38.62v40.44c0,5.57,4.52,10.11,10.11,10.11h17.33c0,7.18,5.82,13,13,13s13-5.82,13-13h27.44v-50.55c0-18.15-11.96-33.51-28.42-38.62ZM94.87,99.66h-27.44v4.03c0,4.41-3.16,8.33-7.52,8.9-5.29.68-9.81-3.44-9.81-8.59v-4.33h-20.22c-3.99,0-7.22-3.24-7.22-7.22v-39c0-16.31,10.86-30.11,25.72-34.59,1.52-.45,3.08-.81,4.66-1.05-1.05-1.08-1.81-2.48-2.09-4.03-.1-.48-.14-.98-.14-1.49,0-4.38,3.57-7.94,7.96-7.94s7.94,3.57,7.94,7.94c0,.51-.04,1.01-.14,1.49-.29,1.55-1.03,2.95-2.08,4.03,1.59.25,3.13.61,4.65,1.05,14.86,4.46,25.74,18.28,25.74,34.59v46.22Z"/>
        </svg>
    );
};

export default LK_Alarm;